import React, { useState, useEffect } from 'react';

const DEFAULT_W = 7, DEFAULT_H = 7;

function idx(x,y,w){return x + y*w}

export default function EnvLab(){
  const [W, setW] = useState(DEFAULT_W);
  const [H, setH] = useState(DEFAULT_H);
  const [walls, setWalls] = useState(new Set());
  const [start, setStart] = useState([0,0]);
  const [goal, setGoal] = useState([DEFAULT_W-1, DEFAULT_H-1]);
  const [dragMode, setDragMode] = useState(null); // 'start'|'goal'|null

  useEffect(()=>{
    // try load last env
    try{
      const raw = localStorage.getItem('dd_env_v1');
      if (raw){ const parsed = JSON.parse(raw); if (parsed.W && parsed.H){ setW(parsed.W); setH(parsed.H); setStart(parsed.start||[0,0]); setGoal(parsed.goal||[parsed.W-1, parsed.H-1]); setWalls(new Set((parsed.walls||[]).map(n=>n))); }
      }
    }catch(e){}
  }, []);

  function toggleWall(x,y){ const i = idx(x,y,W); setWalls(prev => { const n = new Set(prev); if (n.has(i)) n.delete(i); else n.add(i); return n }); }

  function handleCellClick(x,y, e){
    if (dragMode === 'start'){ setStart([x,y]); setDragMode(null); return }
    if (dragMode === 'goal'){ setGoal([x,y]); setDragMode(null); return }
    // if clicked on start/goal ignore wall toggle
    if (start[0]===x && start[1]===y) return;
    if (goal[0]===x && goal[1]===y) return;
    toggleWall(x,y);
  }

  function exportEnv(){ const arr = { W, H, start, goal, walls: Array.from(walls) }; const blob = new Blob([JSON.stringify(arr, null, 2)], {type:'application/json'}); const url = URL.createObjectURL(blob); const a = document.createElement('a'); a.href=url; a.download='gridworld.json'; a.click(); URL.revokeObjectURL(url); }

  function saveEnv(){ const payload = { W, H, start, goal, walls: Array.from(walls) }; localStorage.setItem('dd_env_v1', JSON.stringify(payload)); }

  function clearWalls(){ setWalls(new Set()); }

  function randomMaze(){ const n = Math.floor((W*H)*0.18); const s = new Set(); while(s.size < n){ const x = Math.floor(Math.random()*W); const y = Math.floor(Math.random()*H); const i = idx(x,y,W); if ((x===start[0]&&y===start[1])||(x===goal[0]&&y===goal[1])) continue; s.add(i); } setWalls(s); }

  function resize(w,h){ setW(w); setH(h); setWalls(new Set()); setStart([0,0]); setGoal([Math.max(0,w-1), Math.max(0,h-1)]); }

  return (
    <div style={{ padding: 18 }}>
      <div style={{ display: 'flex', gap: 18 }}>
        <div style={{ minWidth: 420 }}>
          <div style={{ fontFamily: 'Syne', fontSize: 18, fontWeight: 800 }}>Environment Lab — Grid Editor</div>
          <div style={{ marginTop: 6, color: 'var(--t2)' }}>Create gridworlds: click to toggle walls, drag to move start/goal, save/export JSON.</div>

          <div style={{ marginTop: 12, display: 'grid', gridTemplateColumns: `repeat(${W},48px)`, gap: 6 }} onMouseLeave={()=>setDragMode(null)}>
            {Array.from({length:H}).map((_,y)=> Array.from({length:W}).map((__,x)=>{
              const i = idx(x,y,W); const isWall = walls.has(i); const isStart = start[0]===x && start[1]===y; const isGoal = goal[0]===x && goal[1]===y;
              return (
                <div key={i} onMouseDown={(e)=>{ if (isStart){ setDragMode('start'); } else if (isGoal){ setDragMode('goal'); } else handleCellClick(x,y,e); }} onMouseEnter={(e)=>{ if (dragMode==='start') setStart([x,y]); else if (dragMode==='goal') setGoal([x,y]); }} onClick={(e)=>handleCellClick(x,y,e)} style={{ width:48, height:48, border: '1px solid var(--b0)', background: isWall ? 'var(--b0)' : isGoal ? 'var(--gcyan)' : isStart ? 'var(--cyan)' : 'transparent', display:'flex', alignItems:'center', justifyContent:'center', cursor: 'pointer' }}>
                  {isStart ? <div style={{ fontWeight: 800, color: 'var(--void)' }}>S</div> : isGoal ? <div style={{ fontWeight: 800, color: 'var(--void)' }}>G</div> : null}
                </div>
              );
            })).flat()}
          </div>
        </div>

        <div style={{ flex: 1, maxWidth: 420 }}>
          <div style={{ display:'flex', gap:8, marginBottom:10 }}>
            <label style={{ fontSize:12 }}>W <input type="number" min={3} max={20} value={W} onChange={e=>resize(Math.max(3, Math.min(20, parseInt(e.target.value)||DEFAULT_W)), H)} style={{ width:56, marginLeft:6 }} /></label>
            <label style={{ fontSize:12 }}>H <input type="number" min={3} max={20} value={H} onChange={e=>resize(W, Math.max(3, Math.min(20, parseInt(e.target.value)||DEFAULT_H)))} style={{ width:56, marginLeft:6 }} /></label>
          </div>

          <div style={{ display:'flex', gap:8, marginBottom:12, alignItems: 'center' }}>
            <button onClick={clearWalls} style={{ padding:'8px 12px', border: '1px solid var(--b1)', background: 'transparent', color: 'var(--t2)', borderRadius: 3, cursor: 'pointer', fontFamily: 'JetBrains Mono', fontSize: 11 }}>CLEAR WALLS</button>
            <button onClick={randomMaze} style={{ padding:'8px 12px', border: '1px solid var(--b1)', background: 'transparent', color: 'var(--t2)', borderRadius: 3, cursor: 'pointer', fontFamily: 'JetBrains Mono', fontSize: 11 }}>RANDOM MAZE</button>
            <button onClick={saveEnv} style={{ padding:'8px 12px', border: '1px solid var(--b1)', background: 'transparent', color: 'var(--t2)', borderRadius: 3, cursor: 'pointer', fontFamily: 'JetBrains Mono', fontSize: 11 }}>SAVE</button>
            <button onClick={exportEnv} style={{ padding:'8px 12px', border: '1px solid var(--b1)', background: 'transparent', color: 'var(--t2)', borderRadius: 3, cursor: 'pointer', fontFamily: 'JetBrains Mono', fontSize: 11 }}>EXPORT JSON</button>
          </div>

          <div style={{ fontSize:12, color:'var(--t3)', marginBottom:8 }}>Start: [{start.join(', ')}] · Goal: [{goal.join(', ')}] · Walls: {walls.size}</div>
          <div style={{ fontSize:12, color:'var(--t3)' }}>Tip: Click a cell to toggle wall. Click-and-drag the S or G to reposition.</div>
        </div>
      </div>
    </div>
  );
}
